import Vue from 'vue'
import Router from 'vue-router'

import CadastrosIndividuaisRoutes from './routes/CadastrosIndividuais'
import AtendimentosNoMesRoutes from './routes/AtendimentosNoMes'
import UltimasVisualizacoesRoutes from './routes/UltimasVisualizacoes'
import EnvioAppRoutes from './routes/EnvioApp'
import GestaoCadastrosRoutes from './routes/GestaoCadastros'
import InformatizaApsRoutes from './routes/InformatizaAps'
import Iaf from './routes/Iaf'
import Pse from './routes/Pse'
import IndicadoresApsRoutes from './routes/IndicadoresAps'
import ProfissionaisPecCnesRoutes from './routes/ProfissionaisPecCnes'
import AdministracaoRoutes from './routes/Administracao'
import Imunizacao from './routes/Imunizacao'
import VisitasDomiciliaresRoutes from './routes/VisitasDomiciliares'
import SaudeCriancaRoutes from './routes/SaudeCrianca'
import RiscoCardiovascularRoutes from './routes/RiscoCardiovascular'
import ProducaoRoutes from './routes/Producao'
import AedesAegypti from './routes/AedesAegypti'
import PosCovid19 from './routes/PosCovid19'
import ExportarDados from './routes/ExportarDados'
import VinculoAcompanhamento from './routes/VinculoAcompanhamento'
import BpaERas from './routes/BpaERas'
import Ceo from './routes/Ceo'
import Tria from './routes/Tria'
import AvaliacaoTreinamentoAnalise from './routes/AvaliacaoTreinamentoAnalise'
import SaudeBucalRoutes from './routes/SaudeBucal'
import eSfeAPRoutes from './routes/eSFeAP'
import eMultiRoutes from './routes/eMulti'
import OficinasTreinamentosRoutes from './routes/OficinasTreinamentos'
import UpaRoutes from './routes/Upa'
import store from '@/store/store.js'
import { permissoes } from '@/services/Permissoes.js'
import { jwtDecode } from 'jwt-decode'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('./layouts/Login/index.vue'),
      children: [
        {
          path: '/',
          component: () => import('./pages/Index.vue'),
        },
        {
          path: '/nosso-dia-a-dia',
          component: () => import('./pages/NossoDiaDia/Index.vue'),
        },
        {
          path: '/termos-de-uso',
          component: () => import('./pages/Termos.vue'),
        },
        {
          path: '/recursos',
          component: () => import('./pages/Recursos.vue'),
        },
        {
          path: '/uso-cientifico',
          component: () => import('@/pages/UsoCientifico/Index.vue'),
        },
        {
          path: '/avaliacoes',
          component: () => import('./pages/Avaliacoes.vue'),
        },
        {
          path: '/cofinanciamento/mapa-ied',
          component: () =>
            import('./pages/Cofinanciamento/MapaIed/MapaIed.vue'),
        },
        {
          path: '/previne-brasil/regional',
          component: () => import('./pages/PrevineBrasil/Regional.vue'),
        },
        {
          path: '/previne-brasil/municipios-na-meta',
          component: () => import('./pages/PrevineBrasil/MunicipiosNaMeta.vue'),
        },
        {
          path: '/previne-brasil/mapa-desempenho',
          component: () => import('./pages/PrevineBrasil/MapaDesempenho.vue'),
        },
        {
          path: '/previne-brasil/lista',
          component: () => import('./pages/PrevineBrasil/Lista.vue'),
        },
        {
          path: '/previne-brasil/estados',
          component: () => import('./pages/PrevineBrasil/Estados.vue'),
        },
      ],
    },
    {
      path: '/login',
      component: () => import('./pages/Auth/Login.vue'),
    },
    {
      path: '/privacidade',
      component: () => import('./pages/PrivacidadeTermos/Index.vue'),
    },
    {
      path: '/termos-uso',
      component: () => import('./pages/PrivacidadeTermos/Index.vue'),
    },
    {
      path: '/cofinanciamento/simulacao',
      component: () => import('./pages/CofinanciamentoSimulacao/Index.vue'),
    },
    {
      path: '/demonstracao',
      component: () => import('./pages/Auth/Demonstracao.vue'),
    },
    {
      path: '/criar-conta',
      component: () => import('./pages/Auth/CriarConta.vue'),
    },
    {
      path: '/recuperar-senha',
      component: () => import('./pages/Auth/RecuperarSenha.vue'),
    },
    {
      path: '/dashboard',
      component: () => import('./pages/Dashboard.vue'),
    },
    {
      path: '/acesso-negado',
      component: () => import('./pages/Auth/AcessoNegado.vue'),
    },
    {
      path: '/atualizar-cadastro',
      component: () => import('./pages/Auth/AtualizarCadastro.vue'),
    },
    {
      path: '/municipio-negado',
      component: () => import('./pages/Auth/MunicipioNegado.vue'),
    },
    {
      path: '/usuario-inativo',
      component: () => import('./pages/Auth/UsuarioInativo.vue'),
    },
    {
      path: '/lotacoes/:cod_ibge/:nu_cpf',
      component: () => import('./pages/Auth/EscolherAcesso.vue'),
    },
    {
      path: '/atualizacao-cadastro',
      component: () => import('./pages/Auth/AtualizacaoCadastro.vue'),
    },
    {
      path: '/alterar-municipio',
      component: () => import('./pages/Auth/AlterarMunicipio.vue'),
    },
    {
      path: '/orcamento',
      component: () => import('./pages/Orcamento/Index'),
    },
    {
      path: '/proposta',
      component: () => import('./pages/Orcamento/Proposta'),
    },
    {
      path: '/relatorio',
      component: () => import('./pages/Relatorio'),
    },
    {
      path: '/chatbot/fd0066e5-3dc7-4536-a9d6-93740104a790',
      component: () => import('./pages/Chatbot/Index.vue'),
    },
    {
      path: '/suporte/fd0066e5',
      component: () => import('./pages/Suporte/Index.vue'),
    },
    {
      path: '/excluirdados',
      component: () => import('./pages/Auth/TutorialExcluirDados.vue'),
    },
    {
      path: '/pagina-indisponivel',
      component: () => import('./pages/Auth/PaginaIndisponivel.vue'),
    },
    {
      path: '/documentacao',
      component: () => import('./pages/Documentacao/Index.vue'),
      children: [
        {
          path: '/documentacao',
          name: 'Documentacao',
          component: () =>
            import('./pages/Documentacao/Views/Documentacao/index.vue'),
        },
        {
          path: 'administracao',
          name: 'Administracao',
          component: () =>
            import('./pages/Documentacao/Views/Administracao/index.vue'),
        },
        {
          path: 'administracao/indicadores-previne-brasil',
          name: 'IndicadoresPrevineBrasil',
          component: () =>
            import(
              './pages/Documentacao/Views/Administracao/IndicadoresPrevineBrasil/index.vue'
            ),
        },
        {
          path: 'administracao/gerenciar-usuarios',
          name: 'GerenciarUsuarios',
          component: () =>
            import(
              './pages/Documentacao/Views/Administracao/GerenciarUsuarios/index.vue'
            ),
        },
        {
          path: 'administracao/ressincronizacao',
          name: 'Ressincronizacao',
          component: () =>
            import(
              './pages/Documentacao/Views/Administracao/Ressincronizacao/index.vue'
            ),
        },
        {
          path: 'administracao/gerenciar-permissoes',
          name: 'GerenciarPermissoes',
          component: () =>
            import(
              './pages/Documentacao/Views/Administracao/GerenciarPermissoes/index.vue'
            ),
        },
        {
          path: 'cadastros-cidadaos',
          name: 'CadastrosCidadaos',
          component: () =>
            import('./pages/Documentacao/Views/CadastrosCidadaos/index.vue'),
        },
        {
          path: 'indicadores-aps',
          name: 'IndicadoresAps',
          component: () =>
            import('./pages/Documentacao/Views/IndicadoresAps/index.vue'),
        },
        {
          path: 'indicadores-aps/indicador-citologico',
          name: 'IndicadorCitologico',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/IndicadorCitologico/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/indicador-imunizacao',
          name: 'IndicadorImunizacao',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/IndicadorImunizacao/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/pre-natal',
          name: 'PreNatal',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/PreNatal/index.vue'
            ),
        },
        {
          path: 'indicadores-aps/pre-natal/consultas-pre-natal',
          name: 'ConsultasPreNatal',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/PreNatal/ConsultasPreNatal/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/pre-natal/problemas-ativos',
          name: 'ProblemasAtivos',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/PreNatal/ProblemasAtivos/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/pre-natal/consultas-odontologicas',
          name: 'ConsultasOdontologicas',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/PreNatal/ConsultasOdontologicas/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/pre-natal/exames-hiv-sifilis',
          name: 'ExamesHivSifilis',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/PreNatal/ExamesHivSifilis/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/pre-natal/tres-indicadores-pre-natal',
          name: 'TresIndicadoresPreNatal',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/PreNatal/TresIndicadoresPreNatal/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/doencas-cronicas',
          name: 'DoencasCronicas',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/doencas-cronicas/atendimento-diabetes',
          name: 'HemoglobinaGlicada',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/HemoglobinaGlicada/index.vue'
            ),
        },
        {
          path: 'indicadores-aps/doencas-cronicas/atendimento-hipertensao',
          name: 'AtendimentoHipertensao',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/AtendimentoHipertensao/index.vue'
            ),
        },
        {
          path: 'indicadores-aps/doencas-cronicas/hiper-dia',
          name: 'HiperDia',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/DoencasCronicas/HiperDia/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/resultado-isf-acs',
          name: 'ResultadoIsfAcs',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/ResultadoIsfAcs/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/desempenho-por-equipe',
          name: 'DesempenhoPorEquipe',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/DesempenhoPorEquipe/index.vue'
            ),
        },

        {
          path: 'indicadores-aps/desempenho-por-equipe/indicador',
          name: 'Indicador',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/DesempenhoPorEquipe/Indicador/index.vue'
            ),
        },
        {
          path: 'indicadores-aps/desempenho-por-equipe/geral',
          name: 'Geral',
          component: () =>
            import(
              './pages/Documentacao/Views/IndicadoresAps/DesempenhoPorEquipe/Geral/index.vue'
            ),
        },

        {
          path: 'gestao-cadastros',
          name: 'GestaoCadastros',
          component: () =>
            import('./pages/Documentacao/Views/GestaoCadastros/index.vue'),
        },
        {
          path: 'gestao-cadastros/acs-por-cidadao',
          name: 'AcsPorCidadao',
          component: () =>
            import(
              './pages/Documentacao/Views/GestaoCadastros/AcsPorCidadao/index.vue'
            ),
        },
        {
          path: 'gestao-cadastros/busca-ativa-cadastro',
          name: 'BuscaAtivaCadastro',
          component: () =>
            import(
              './pages/Documentacao/Views/GestaoCadastros/BuscaAtivaCadastro/index.vue'
            ),
        },
        {
          path: 'gestao-cadastros/cidadaos-duplicados',
          name: 'CidadaosDuplicados',
          component: () =>
            import(
              './pages/Documentacao/Views/GestaoCadastros/CidadaosDuplicados/index.vue'
            ),
        },
        {
          path: 'gestao-cadastros/cadastros-sem-cpf',
          name: 'CadastrosSemCpf',
          component: () =>
            import(
              './pages/Documentacao/Views/GestaoCadastros/CadastrosSemCpf/index.vue'
            ),
        },
        {
          path: 'visitas-domiciliares',
          name: 'VisitasDomiciliares',
          component: () =>
            import('./pages/Documentacao/Views/VisitasDomiciliares/index.vue'),
        },
        {
          path: 'visitas-domiciliares/cidadaos-visitados',
          name: 'CidadaosVisitados',
          component: () =>
            import(
              './pages/Documentacao/Views/VisitasDomiciliares/CidadaosVisitados/index.vue'
            ),
        },
        {
          path: 'visitas-domiciliares/familias-visitadas',
          name: 'FamiliasVisitadas',
          component: () =>
            import(
              './pages/Documentacao/Views/VisitasDomiciliares/FamiliasVisitadas/index.vue'
            ),
        },
        {
          path: 'visitas-domiciliares/desempenho-por-microarea',
          name: 'DesempenhoPorAcs',
          component: () =>
            import(
              './pages/Documentacao/Views/VisitasDomiciliares/DesempenhoPorMicroArea/index.vue'
            ),
        },
        {
          path: 'atendimentos-no-mes',
          name: 'AtendimentosNoMes',
          component: () =>
            import('./pages/Documentacao/Views/AtendimentosNoMes/index.vue'),
        },
        {
          path: 'envio-app-acs-pec',
          name: 'EnvioAppAcsPec',
          component: () =>
            import('./pages/Documentacao/Views/EnvioAppAcsPec/index.vue'),
        },
        {
          path: 'informatiza-aps',
          name: 'InformatizaAps',
          component: () =>
            import('./pages/Documentacao/Views/InformatizaAps/index.vue'),
        },
        {
          path: 'risco-cardio-vascular',
          name: 'RiscoCardiovascular',
          component: () =>
            import('./pages/Documentacao/Views/RiscoCardioVascular/index.vue'),
        },
      ],
    },
    {
      path: '/previne-brasil/simulador',
      component: () => import('./pages/PrevineBrasil/Simulador/index.vue'),
    },
    {
      path: '/avaliacao-treinamento',
      component: () => import('./pages/AvaliacaoTreinamento/Index.vue'),
    },
    {
      path: '/iaf',
      component: () => import('./pages/Iaf/Index.vue'),
    },
    {
      path: '/cofinanciamento/mapa-ubs',
      component: () => import('./pages/Cofinanciamento/MapaUbs/MapaUbs.vue'),
    },
    {
      path: '/pse',
      component: () => import('./pages/Pse/Index.vue'),
    },
    {
      path: '/oficina-monitoramento-avaliacao',
      component: () =>
        import('./pages/OficinaMonitoramenteAvaliacao/index.vue'),
    },
    {
      path: '/oficina-monitoramento-avaliacao/apresentacao',
      component: () =>
        import('./pages/OficinaMonitoramenteAvaliacao/index.vue'),
    },
    {
      path: '/atendimentos-pessoa',
      component: () => import('@/pages/AtendimentosPessoa/Index.vue'),
    },

    ...CadastrosIndividuaisRoutes,
    ...AtendimentosNoMesRoutes,
    ...UltimasVisualizacoesRoutes,
    ...EnvioAppRoutes,
    ...GestaoCadastrosRoutes,
    ...InformatizaApsRoutes,
    ...Iaf,
    ...Pse,
    ...IndicadoresApsRoutes,
    ...ProfissionaisPecCnesRoutes,
    ...AdministracaoRoutes,
    ...Imunizacao,
    ...VisitasDomiciliaresRoutes,
    ...SaudeCriancaRoutes,
    ...RiscoCardiovascularRoutes,
    ...ProducaoRoutes,
    ...AedesAegypti,
    ...PosCovid19,
    ...ExportarDados,
    ...VinculoAcompanhamento,
    ...BpaERas,
    ...Tria,
    ...AvaliacaoTreinamentoAnalise,
    ...Ceo,
    ...SaudeBucalRoutes,
    ...eSfeAPRoutes,
    ...eMultiRoutes,
    ...OficinasTreinamentosRoutes,
    ...UpaRoutes,
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  // rotas públicas
  if (
    to.path == '/' ||
    to.path == '/termos-uso' ||
    to.path == '/privacidade' ||
    to.path == '/login' ||
    to.path == '/demonstracao' ||
    to.path == '/cofinanciamento/simulacao' ||
    to.path == '/criar-conta' ||
    to.path == '/recuperar-senha' ||
    to.path == '/acesso-negado' ||
    to.path == '/atualizar-cadastro' ||
    to.path == '/municipio-negado' ||
    to.path == '/usuario-inativo' ||
    to.path == '/atualizacao-cadastro' ||
    to.path == '/orcamento' ||
    to.path == '/proposta' ||
    to.path == '/relatorio' ||
    to.path == '/avaliacoes' ||
    to.path == '/uso-cientifico' ||
    to.path == '/cofinanciamento/mapa-ied' ||
    to.path == '/cofinanciamento/mapa-ubs' ||
    to.path == '/previne-brasil/lista' ||
    to.path == '/previne-brasil/estados' ||
    to.path == '/previne-brasil/regional' ||
    to.path == '/previne-brasil/municipios-na-meta' ||
    to.path == '/previne-brasil/mapa-desempenho' ||
    to.path == '/previne-brasil/simulador' ||
    to.path.includes('/atendimentos-no-mes/detalhar') ||
    to.path == '/chatbot/fd0066e5-3dc7-4536-a9d6-93740104a790' ||
    to.path == '/documentacao' ||
    to.path == '/documentacao/administracao' ||
    to.path == '/documentacao/administracao/indicadores-previne-brasil' ||
    to.path == '/documentacao/administracao/gerenciar-usuarios' ||
    to.path == '/documentacao/administracao/ressincronizacao' ||
    to.path == '/documentacao/administracao/gerenciar-permissoes' ||
    to.path == '/documentacao/cadastros-cidadaos' ||
    to.path == '/documentacao/gestao-cadastros' ||
    to.path == '/documentacao/gestao-cadastros/acs-por-cidadao' ||
    to.path == '/documentacao/gestao-cadastros/cidadaos-sem-equipe' ||
    to.path == '/documentacao/gestao-cadastros/cidadaos-duplicados' ||
    to.path == '/documentacao/gestao-cadastros/cadastros-sem-cpf' ||
    to.path == '/documentacao/visitas-domiciliares' ||
    to.path == '/documentacao/visitas-domiciliares/cidadaos-visitados' ||
    to.path == '/documentacao/visitas-domiciliares/familias-visitadas' ||
    to.path == '/documentacao/visitas-domiciliares/desempenho-por-microarea' ||
    to.path == '/documentacao/atendimentos-no-mes' ||
    to.path == '/documentacao/envio-app-acs-pec' ||
    to.path == '/documentacao/informatiza-aps' ||
    to.path == '/documentacao/indicadores-aps' ||
    to.path == '/documentacao/indicadores-aps/indicador-citologico' ||
    to.path == '/documentacao/indicadores-aps/indicador-imunizacao' ||
    to.path == '/documentacao/indicadores-aps/pre-natal' ||
    to.path == '/documentacao/indicadores-aps/pre-natal/consultas-pre-natal' ||
    to.path == '/documentacao/indicadores-aps/pre-natal/problemas-ativos' ||
    to.path ==
      '/documentacao/indicadores-aps/pre-natal/consultas-odontologicas' ||
    to.path == '/documentacao/indicadores-aps/pre-natal/exames-hiv-sifilis' ||
    to.path ==
      '/documentacao/indicadores-aps/pre-natal/tres-indicadores-pre-natal' ||
    to.path == '/documentacao/indicadores-aps/doencas-cronicas' ||
    to.path ==
      '/documentacao/indicadores-aps/doencas-cronicas/atendimento-diabetes' ||
    to.path ==
      '/documentacao/indicadores-aps/doencas-cronicas/atendimento-hipertensao' ||
    to.path == '/documentacao/indicadores-aps/doencas-cronicas/hiper-dia' ||
    to.path == '/documentacao/indicadores-aps/resultado-isf-acs' ||
    to.path == '/documentacao/indicadores-aps/desempenho-por-equipe' ||
    to.path ==
      '/documentacao/indicadores-aps/desempenho-por-equipe/indicador' ||
    to.path == '/documentacao/indicadores-aps/desempenho-por-equipe/geral' ||
    to.path == '/documentacao/risco-cardio-vascular' ||
    to.path == '/suporte/fd0066e5' ||
    to.path == '/excluirdados' ||
    to.path == '/avaliacao-treinamento' ||
    to.path == '/pagina-indisponivel' ||
    to.path == '/nosso-dia-a-dia'
  ) {
    next()
    return
  }

  // Se não tiver token, não permite a entrada
  if (store.getters.getAccessToken == null) {
    store.dispatch('logout')
    next('/login')
    return
  }

  // Verifica se o usuário precisa alterar a senha por questões de segurança
  if (store.getters.getRequiredPasswordUpdate) {
    next('/atualizacao-cadastro')
    return
  }

  // A página dashboard deve ser verificada especificamente por que ela não é montada no momento de organizar as permissões
  if (to.path.includes('/dashboard')) {
    if (store.getters.getAccessToken == null) {
      store.dispatch('logout')
      next('/login')
      return
    } else {
      next()
      return
    }
  }

  // A página de lotações só é permitida para Médico, enfermeiro, odontólogo, téc. saúde bucal, emulti, recepcionista
  if (to.path.includes('/lotacoes')) {
    if (
      store.getters.getIdFuncao == 4 ||
      store.getters.getIdFuncao == 5 ||
      store.getters.getIdFuncao == 8 ||
      store.getters.getIdFuncao == 14 ||
      store.getters.getIdFuncao == 15
    ) {
      next()
      return
    } else {
      store.dispatch('logout')
      next('/login')
      return
    }
  }

  // Página para alterar o município
  if (to.path.includes('/alterar-municipio')) {
    if (store.getters.getAccessToken == null) {
      store.dispatch('logout')
      next('/login')
      return
    } else {
      next()
      return
    }
  }

  // verificação das rotas
  const token = store.state.accessToken
  const decoded = jwtDecode(token)

  const perfil = permissoes.find((item) => {
    return (
      item.id_perfil == Number(store.state.id_funcao) &&
      item.nome == decoded.funcao
    )
  })
  let authorization = false
  if (
    decoded.cod_ibge == Number(store.state.cod_ibge) &&
    decoded.id_funcao == Number(store.state.id_funcao) &&
    (decoded.funcao == perfil.nome || perfil.nome.includes(decoded.funcao))
  ) {
    for (const key in perfil) {
      if (key !== 'nome' && key !== 'id_perfil') {
        for (let index = 0; index < perfil[key].length; index++) {
          const element = perfil[key][index]
          if (element.link == to.path) {
            authorization = true
          }
        }
      }
    }
  }

  if (!authorization) {
    store.dispatch('logout')
    next('/login')
  } else {
    next()
  }
})

export default router
